module.exports = __webpack_public_path__ + "img/20211224130949155588.de29ff77.png";